import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { adminApi } from './admin.api';
import type { LiveStatusResponse } from '@/types/api';

export const LIVE_STATUS_KEY = ['admin', 'live'] as const;

/**
 * Polls /admin/live every 5 seconds while the tab is visible.
 *
 * `placeholderData: keepPreviousData` avoids flashing the empty state
 * between refetches — the previous snapshot stays visible while the new
 * one is being fetched.
 *
 * Tanstack-query auto-pauses the interval when the tab is in the
 * background (refetchIntervalInBackground default = false), so we don't
 * burn requests when nobody's watching.
 */
export function useLiveStatus() {
  return useQuery<LiveStatusResponse>({
    queryKey: LIVE_STATUS_KEY,
    queryFn: adminApi.liveStatus,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
    staleTime: 0,
  });
}
